//export const API_URL = 'https://pal.diginestsolutions.in/public/api';
//export const API_URL = 'https://192.168.1.54/public/api/';

// 1- corporate, 2-ta, 3-customer, 4 -supplier

export const env = "client"

const URLS = {
    client: "https://limotransferv1.otademo.com/",
    // client: "http://127.0.0.1:8000/api",
}

const url = {
    client:"https://limotransferv1.otademo.com/public/api",
    // client: "http://127.0.0.1:8000/api",
}

const viewurl = {
    client:"https://limotransferv1.otademo.com/public/auth/",  
}

const image = {
    client: "https://limotransferv1.otademo.com/assets/img/vehicles/",
}

const noshow = {
    client: "https://limotransferv1.otademo.com/storage/",
}

const vehicleType = {
    client: "https://limotransferv1.otademo.com/public/assets/img/",
    // client: "http://127.0.0.1:8000/assets/img/",
}

const key = {
    client:"nGw3tbaew9KgjGiXf3JwVnNEDUS4pmsA",
}

//'https://apidev.myfutton.com' //Dev mode= http://apidev.myfutton.com //Live Mode='http://api.myfutton.com';
//Dev mode= http://apidev.myfutton.com/api/v1/student //Live Mode=http://api.myfutton.com/api/v1/student';

export const BASE_URL = URLS[env]
export const IMAGE_URL = image[env]
export const NO_SHOW_IMG = noshow[env]
export const VIEW_URL = viewurl[env]
export const VEHICLETYPE_IMG = vehicleType[env]


export const API_URL = `${url[env]}`
export const API_KEY = `${key[env]}`



